import axios from 'axios'

// state
export const state = {
  isQrCodeLoading: false,
  qrCode: null,
  qrCodeLanding: null,
}

// getters
export const getters = {}

// mutations
export const mutations = {
  fetchQrCodeStarted(state) {
    state.isQrCodeLoading = true
  },
  fetchQrCodeSuccess(state, { qrCode }) {
    state.qrCode = qrCode
    state.isQrCodeLoading = false
  },
  fetchQrCodeLandingSuccess(state, { qrCode }) {
    state.qrCodeLanding = qrCode
    state.isQrCodeLoading = false
  },
  fetchQrCodeFailed(state) {
    state.isQrCodeLoading = false
  },
}
// actions
export const actions = {
  async fetchQrCode({ commit, state: { qrCode } }) {
    if (qrCode) {
      return qrCode
    }
    try {
      commit('fetchQrCodeStarted')
      const qrCode = await axios.get(`qr/1`)
      commit('fetchQrCodeSuccess', {
        qrCode: qrCode.code.image_url,
      })
    } catch (e) {
      commit('fetchQrCodeFailed')
    }
  },
  async fetchQrCodeLanding({ commit, state: { qrCodeLanding } }) {
    if (qrCodeLanding) {
      return qrCodeLanding
    }
    try {
      commit('fetchQrCodeStarted')
      const qrCode = await axios.get(`qr/1`)
      commit('fetchQrCodeLandingSuccess', {
        qrCode: qrCode.code.image_url,
      })
    } catch (e) {
      commit('fetchQrCodeFailed')
    }
  },
}
